module.exports = __webpack_public_path__ + "img/HINDU GREEN.c566a95.svg";